import request from '@/utils/request';
import { getSystemConfig } from '@/api/setting/config';
import { getSystemTime } from '@/api/home';

const baseURL = '/userapi/user/'

export const login = data =>
  request({
    data,
    url: `${baseURL}login`,
    method: 'post'
  });

export const getCaptcha = params =>
  request({
    params,
    url: `${baseURL}captcha`,
    method: 'get'
  });

export const getUserInfo = data =>
  request({
    data,
    url: `${baseURL}info`,
    method: 'post'
  });

export const refreshToken = data =>
  request({
    data,
    url: `${baseURL}token/refresh`,
    method: 'post'
  });

export const logout = data =>
  request({
    data,
    url: `${baseURL}logout`,
    method: 'post'
  });

export const getSelectableMonth = async () => {
  const response = await request({
    url: `/financeapi/finance/home/accountSet/getPeriodList`,
    method: 'get',
    params: { format: 'yyyy-MM' }
  });
  return response.data.map(i => {
    const segments = i.split('-');
    return {
      label: segments[0] + '年' + segments[1] + '月',
      value: i,
      seasonLabel: segments[0] + '年第' + Math.ceil(segments[1] / 3) + '季度',
      seasonValue: segments[0] + '-0' + Math.ceil(segments[1] / 3)
    }
  });
}

export const getSelectableMonthToNow = async () => {
  // 获取启用日期
  const response1 = await getSystemConfig();
  const beginDate = new Date(response1.data.beginDate);
  let beginYear = beginDate.getFullYear();
  let beginMouth = beginDate.getMonth() + 1;
  // 获取系统服务器日期
  const response2 = await getSystemTime();
  const nowDate = new Date(response2.data.systemTime);
  const nowYear = nowDate.getFullYear();
  const nowMouth = nowDate.getMonth() + 1;
  // 计算可选日期范围
  const selectableDate = [];
  while (
    beginYear < nowYear ||
    (beginYear === nowYear && beginMouth <= nowMouth)
  ) {
    let strMouth = beginMouth.toString();
    if (strMouth.length === 1) {
      strMouth = '0' + strMouth;
    }
    selectableDate.push({
      label: beginYear + '年' + strMouth + '月',
      value: beginYear + '-' + strMouth,
      seasonLabel: beginYear + '年第' + Math.ceil(beginMouth / 3) + '季度',
      seasonValue: beginYear + '-0' + Math.ceil(beginMouth / 3)
    });
    beginMouth++;
    if (beginMouth === 13) {
      beginYear++;
      beginMouth = 1;
    }
  }
  return selectableDate;
}
